var scrollTo = function scrollTo(selector) {
  var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';
  // eslint-disable-next-line no-undef
  var element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: block
    });
  }
};
var scrollTo$1 = scrollTo;

export { scrollTo$1 as default };
//# sourceMappingURL=scrollTo.js.map
